import { useState } from "react";

function MenuFeature(props) {
  const [open, setOpen] = useState(true);

  const classname = `c-menu-feature${ !open ? '--hidden' : ''}`;

  return (
    <div className={classname}>
      <div className="c-menu-feature--content">
        <div className="c-menu-feature--title" onClick={() => { setOpen(!open) }}>
          <p>{props.title}</p>
          <p className="c-menu-feature--title__arrow"><i className="material-icons">{open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i></p>
        </div>
        <div className="c-menu-feature--main">
          {props.children}
        </div>
      </div>
    </div>
  );
}

export default MenuFeature;
